/**
 * Concept 1 mega menu: swap the preview pane (image, title, count, link)
 * when hovering a sub-collection link. Uses event delegation so it keeps
 * working even if the header menu re-renders or moves items into the
 * overflow ("More") menu.
 */
(function () {
  var DEFAULTS = new WeakMap();

  function stateFromLink(link) {
    return {
      img: link.getAttribute('data-mm-img') || '',
      title: link.getAttribute('data-mm-title') || '',
      count: link.getAttribute('data-mm-count') || '',
      prix: link.getAttribute('data-mm-prix') || '',
      rang: link.getAttribute('data-mm-rang') || '',
      url: link.getAttribute('data-mm-url') || '',
    };
  }

  function defaultState(preview) {
    if (DEFAULTS.has(preview)) return DEFAULTS.get(preview);
    var state = {
      img: preview.getAttribute('data-mm-default-img') || '',
      title: preview.getAttribute('data-mm-default-title') || '',
      count: preview.getAttribute('data-mm-default-count') || '',
      prix: preview.getAttribute('data-mm-default-prix') || '',
      rang: preview.getAttribute('data-mm-default-rang') || '',
      url: preview.getAttribute('data-mm-default-url') || '',
    };
    DEFAULTS.set(preview, state);
    return state;
  }

  function apply(preview, state) {
    if (!state) return;

    var media = preview.querySelector('[data-mm-media]');
    var img = preview.querySelector('[data-mm-img-el]');
    var titleEl = preview.querySelector('[data-mm-pane-title]');
    var countEl = preview.querySelector('[data-mm-pane-count]');
    var prixEl = preview.querySelector('[data-mm-pane-prix]');
    var rangEl = preview.querySelector('[data-mm-pane-rang]');
    var paneLink = preview.querySelector('[data-mm-pane]');

    if (img && media) {
      if (state.img) {
        if (img.getAttribute('src') !== state.img) {
          img.style.opacity = '0';
          var loader = new Image();
          loader.onload = function () {
            img.src = state.img;
            media.classList.remove('mm-preview__media--empty');
            img.style.opacity = '1';
          };
          loader.src = state.img;
        } else {
          media.classList.remove('mm-preview__media--empty');
          img.style.opacity = '1';
        }
      } else {
        media.classList.add('mm-preview__media--empty');
      }
    }

    if (titleEl) titleEl.textContent = state.title;
    if (countEl) countEl.textContent = state.count ? state.count + ' modèles' : '';
    if (prixEl) prixEl.textContent = state.prix ? 'dès ' + state.prix : '';
    if (rangEl) rangEl.textContent = state.rang || '';
    if (paneLink && state.url) paneLink.setAttribute('href', state.url);
  }

  document.addEventListener('mouseover', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('.mm-preview__link') : null;
    if (!link) return;
    var preview = link.closest('[data-mm-preview]');
    if (!preview) return;
    defaultState(preview);
    apply(preview, stateFromLink(link));
  });

  /**
   * Anchor each top-level mega menu panel under its own menu item, shifting it
   * left just enough to stay within the viewport (so a right-side item like
   * "Accessoires" doesn't overflow the page edge). Runs on load and on resize.
   */
  function positionPanels() {
    var margin = 24;
    var vw = document.documentElement.clientWidth;
    var items = document.querySelectorAll(
      '.header-menu .menu-list__list-item:not([slot="overflow"])'
    );
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var sub = li.querySelector(':scope > .menu-list__submenu');
      if (!sub) continue;
      var card = sub.querySelector('.mm-preview');
      var cardW = card ? card.getBoundingClientRect().width || 700 : 700;
      var liLeft = li.getBoundingClientRect().left;
      var left = 0;
      if (liLeft + cardW > vw - margin) left = vw - margin - (liLeft + cardW);
      if (liLeft + left < margin) left = margin - liLeft;
      sub.style.setProperty('--mm-anchor-left', Math.round(left) + 'px');
    }
  }

  var rafId = null;
  function schedulePosition() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      positionPanels();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionPanels);
  } else {
    positionPanels();
  }
  window.addEventListener('resize', schedulePosition);
  window.addEventListener('load', positionPanels);

  // The header hydrates/re-renders its submenu nodes after load, which clears the
  // inline anchor offset. Recompute whenever the pointer enters a top-level item
  // (before its panel opens) so the anchoring is always fresh.
  document.addEventListener('pointerover', function (event) {
    var t = event.target;
    if (
      t &&
      t.closest &&
      t.closest('.header-menu .menu-list__list-item:not([slot="overflow"])')
    ) {
      positionPanels();
    }
  });

  document.addEventListener('mouseout', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('.mm-preview__link') : null;
    if (!link) return;
    var preview = link.closest('[data-mm-preview]');
    if (!preview) return;

    var related = event.relatedTarget;
    var list = preview.querySelector('.mm-preview__list');
    if (related && list && list.contains(related)) return;

    apply(preview, defaultState(preview));
  });
})();
